module.exports = __webpack_public_path__ + "img/low_confidence_icon.dcd00b45.svg";